import { render, staticRenderFns } from "./RemainingBon.vue?vue&type=template&id=61863244&scoped=true"
import script from "./RemainingBon.vue?vue&type=script&lang=js"
export * from "./RemainingBon.vue?vue&type=script&lang=js"
import style0 from "./RemainingBon.vue?vue&type=style&index=0&id=61863244&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61863244",
  null
  
)

export default component.exports